import React from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../images/logo.png";
import CheckIcon from "../icons/check-circle.svg";
import XCircleIcon from "../icons/x-circleW.svg";

const MobileInterface = () => {
  const location = useLocation();
  const state = (location && location.state) || {};

  const verified = state.verified ?? false;
  const reasonCode = state.reasonCode ?? "";
  const message = state.message ?? "";

  const hasMsg = Boolean(message);
  const bannerBg = verified ? "bg-[#0AD69FC7]" : reasonCode ? "bg-[#EF466FA8]" : "bg-slate-500";
  const bannerBorder = verified ? "border-[#13C190]" : reasonCode ? "border-[#EF466F]" : "border-slate-500";

  const Icon = () =>
    verified ? (
      <img src={CheckIcon} alt="Success" className="w-5 h-5 flex-none" />
    ) : (
      <img src={XCircleIcon} alt="Error" className="w-5 h-5 flex-none" />
    );

  const cssVars = {
    '--top-offset': '5vh',                                          
    '--mid-nudge-up': 'clamp(0px, 4vh, 48px)',                      
    '--mid-title-gap': 'clamp(8px, 2vh, 16px)',                     
    '--mid-para-gap': 'clamp(12px, 3vh, 24px)',                    
    '--safe-bottom': 'max(0px, env(safe-area-inset-bottom))',      
  };

  const blurStyle = {
    position: "absolute",
    width: "100%",
    height: "200px",
    background: "#6379F5",
    opacity: 0.14,
    filter: "blur(50px)",
    zIndex: 0,
  };

  return (
    <div
      className="relative min-h-[100svh] grid grid-rows-[auto_1fr_auto] overflow-hidden"
      style={cssVars}
    >
      <div style={blurStyle} />

      <div className="absolute inset-0 bg-[#F9FAFC] z-[-200]" />

      <div
        className="absolute inset-x-0 bottom-0 w-full h-1/3 bg-cover bg-no-repeat bg-top pointer-events-none"
        style={{
          backgroundImage: `url(${require("../images/Image.png")})`,
          backgroundSize: "110% auto",
        }}
      />

      <header className="row-start-1 flex justify-center" style={{ marginTop: 'var(--top-offset)' }}>
        <img src={logo} alt="GrayFox Logo" className="h-10" />
      </header>

      <main className="row-start-2 place-self-center px-6 text-center -translate-y-[var(--mid-nudge-up)]">
        <h2 className="text-[18px] font-semibold text-[#38485C] mb-[var(--mid-title-gap)]">
          GrayFox is not yet supported on mobile browsers.
        </h2>
        <p className="text-[16px] text-[#38485C] max-w-xs mx-auto mb-[var(--mid-para-gap)]">
          To use <span className="font-semibold text-primary">GrayFox</span>,
          please log in on your computer via{" "}
          <a
            href="https://app.grayfox.ma/login"
            className="text-[#38485C] font-semibold hover:underline"
          >
            app.grayfox.ma/login
          </a>
          , or download the GrayFox Android app from the Play Store.
        </p>
      </main>

      <footer
        className="row-start-3 flex flex-col items-center text-center px-6 w-full max-w-md justify-self-center mb-6"
        style={{ paddingBottom: 'var(--safe-bottom)' }}
      >
        {!hasMsg && (
          <p className="text-[16px] font-medium text-[#38485C] mb-4">
            New here? You can still{" "}
            <Link to="/signup" className="text-primary font-medium hover:underline">
              sign up
            </Link>{" "}
            on your phone to create an account.
          </p>
        )}

        <Link
          to="/signup"
          className="bg-primary w-full text-white font-bold text-[16px] py-3 px-8 rounded-[12px] hover:bg-[#5a68e0] transition"
        >
          Sign Up
        </Link>

        {hasMsg && (
          <div
            role="status"
            className={`${bannerBg} ${bannerBorder} border-2 w-full text-white font-semibold text-[16px] mt-4 py-3 px-4 rounded-[12px] flex items-center justify-center gap-2`}
          >
            <Icon />
            <span>{message}</span>
          </div>
        )}
      </footer>
    </div>
  );
};

export default MobileInterface;
